import axios from 'axios';
import { Feature } from '@/models/backend/FeatureModels';
import {ListingApiEndpoint} from "@/beepallet.consts";


export const featureService = {
    /**
     * Search features from the API
     * @param {Object} params - Query parameters for the search request
     * @returns {Promise<Feature[]>} - List of features
     */
    async searchFeatures(params: any): Promise<Feature[]> {

        const response = await axios.get(`${ListingApiEndpoint}/api/features/search`, {
            params,
        });
        return response.data.results;
    },
};
